import { createFileRoute, redirect } from "@tanstack/react-router";
import { ENABLE_PT } from "../config";

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    let lang = "en";
    if (typeof window !== "undefined") {
      const savedLang = localStorage.getItem("bizu-lang");
      if (savedLang && (savedLang === "en" || (ENABLE_PT && savedLang === "pt"))) {
        lang = savedLang;
      } else {
        const browserLanguage = navigator.language;
        if (ENABLE_PT && browserLanguage && browserLanguage.startsWith("pt")) {
          lang = "pt";
        }
        localStorage.setItem("bizu-lang", lang);
      }
    }
    throw redirect({
      to: "/$lang",
      params: { lang },
    });
  },
});

